// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import ECharts from "./components/ECharts.vue";
import router from "./router";
import dataV from '@jiaminghi/data-view';
import "amfe-flexible"
Vue.use(dataV)
Vue.use(Element);
Vue.use(ECharts)
Vue.use(router)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>',
  router, // 使用路由配置
  //这行代码与template作用相同 render: h => h(App),
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js